<template>
  <div class="message-window"
       id="message-window">
    <div class="messages">
      <v-message
          v-for="message in IClassroom.messages"
          :key="'message-' + message.innerId"
          :message="message"></v-message>

      <div v-if="IClassroom.autoplay.couldContinue"
           :style="{'top': IClassroom.messageWindowHeight + 'px'}"
           class="continue">
        <span class="text">方向键 ↓ 快进</span>
      </div>
    </div>
  </div>
</template>

<script>
import IClassroom from '../lib/IClassroom'
import VMessage from '../messages/Message'
import { MessageType } from '@/components/classroom/lib/Message'
import _ from 'lodash'

const IDE = window['IDE']

export default {
  name: 'message-window',
  components: { VMessage },
  data () {
    return {
      IClassroom,
      IDE: IDE,
      keydownHandler: _.throttle(this.keyDown, 300)
    }
  },
  mounted () {
    const msg = IClassroom.createMessage('system', MessageType.SYS, { text: '欢迎 ' + IClassroom.user.name + ' 进入教室' })
    IClassroom.$emit('message', msg)

    window.addEventListener('keydown', this.keydownHandler)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.keydownHandler)
  },
  methods: {
    async keyDown (event) {
      if ((event.key === 'ArrowDown' || event.key === ' ') && IClassroom.autoplay.couldContinue) {
        IClassroom.requestNextMessage()
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.message-window {
  width 100%
  padding 2em 2em 0 2em
  margin 0 auto
  background $neBg
  height 100%
  overflow auto
  position relative
}

.messages {
  position relative
  padding-bottom 30%
}

.button:last-child {
  margin-right 0
}

#notification-sound {
  width 0
  height 0
  position absolute
}

.continue {
  position absolute
  right 10px
  margin-left 5rem
  font-size 12px
  text-align center
  transition all .3s
  z-index $zIndexFixed - 1

  .text {
    opacity 0.1
  }

  &:hover .text {
    opacity 1
  }

  &:before {
    content ''
    position absolute
    bottom -10px
    left calc(50% - 10px)
    width: 0;
    height: 0;
    border-style: solid;
    border-radius 5px
    border-width: 10px 10px 0 10px;
    border-color: orange transparent transparent transparent;
    animation moveUpDown 1s infinite
  }
}


</style>
